/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useReducer,
} from "react";
import { Text } from '@vds/core';
import useFetchStreetAddr from "./customHooks/useFetchStreetAddr";
import {
  SuggestionListDiv,
  StreetInputDiv,
  StreetInput,
} from "../styledComponents";
import { useDispatch, useSelector } from "react-redux";
import { getStreetAddress } from "../../../ducks/CheckoutSlice";
import { setAPIError } from "pages/Mobility/ducks/MobilitySlice";
// import { reducer } from '../../../ducks/CheckoutSlice'

const MapQStreetAddress = forwardRef((props, ref) => {
  // const [state, dispatch] = useReducer(reducer, INITIAL_STATE);
  const defaultValue = props?.placeHolder ?? "Eg. 123 Street Name, City, State, Zip Code";
  const [userInput, setUserInput] = useState(props?.isVerifyBussiness ? "" : defaultValue);
  const [isDirty, setIsDirty] = useState(false);
  const [outSideClick, setOutsideClick] = useState(true);
  // const suggestionList = useFetchStreetAddr(userInput)
  const [isSuccess, setIsSuccess] = useState(false);
  const inputRef = useRef();
  const dispatch = useDispatch();
  const pageData = useSelector((state) => state.CheckoutPage);

  useEffect(()=> {
    if(props?.addressLineOne && (props?.isVerifyBussiness || props?.pdp)) {
      setUserInput(props?.addressLineOne || "");
      setIsSuccess(!!props?.addressLineOne || false);
    } else if(!!props?.prospectAddress && props?.prospectAddress?.length > 0){
      setUserInput(props?.prospectAddress || "");
    } else if(props?.addressLineOne && props?.isMultiShipping && !props?.isVerifyBussiness){
      setUserInput(props?.addressLineOne || "");
      // setIsSuccess(!!props?.addressLineOne || false);
    } else if(props?.isFromPayment) {
      setUserInput(props?.addressLineOne || "");
    } else if(!props?.fromNpaNxx && (!props?.pdp || props.emptyAddress)){
      setUserInput(defaultValue);
    } else if(props?.fromNpaNxx){
      setUserInput(props?.value);
      setIsSuccess(!!props?.value || false);
    }
  },[props?.addressLineOne, ,props?.prospectAddress]);

  const onChangeHandler = (e) => {
    let value = e.target.value;
    props?.fromShoppingCart && dispatch(setAPIError(false));
    if (value[0] == ' ') value = value.replace(/\ /, '');
    if(!value) props.setAddressFieldError(true);
    if (value.length > 1) {
      dispatch(getStreetAddress(value));
    }
    props?.handleAddressInput(e, "street")
    setIsDirty(true);
    setUserInput(value);
    setOutsideClick(false);
    props?.isAddressEmty || props.isNewAddress ? "" :props.onSelectionChange(null) 
    setIsSuccess(false);
    matchStreetAddress(value);
    if (!value && userInput !== defaultValue && !props?.isVerifyBussiness && !props?.isMultiShipping && !props?.addressLineOne && !props?.pdp && !props?.isFromPayment && !props?.isEmergencyAdd) {
      setUserInput(defaultValue);
      props.setAddressFieldError(true);
      setOutsideClick(true);              
    } 
  };
  const selectThisStreetAddress = (selectedStreetAddress) => {
    const selection = props.isNameOnly
      ? selectedStreetAddress.name
      : selectedStreetAddress.displayString;
    setOutsideClick(true);
    setUserInput(selection);
    // selectedStreetAddress.displayString = selectedStreetAddress.displayString
        props.onSelectionChange(selectedStreetAddress);
    props.setAddressFieldError(false)
    setIsSuccess(!!selectedStreetAddress);
  };

  useEffect(() => {
    if (userInput) matchStreetAddress(userInput);
  }, [pageData.addressSuggestionList]);

  const matchStreetAddress = (userInput) => {
    if (pageData.addressSuggestionList && userInput) {
      pageData.addressSuggestionList.map((value) => {
        if (formatString(value.displayString) === formatString(userInput)) {
          setOutsideClick(true);
          if (value.ntasAddrID) {
            value.baseAddressId = value.ntasAddrID;
          }
                    props.onSelectionChange(value);
          setIsSuccess(true);
        }
      });
    }
  };

  const formatString = (str) => {
    return str
      ? str.replace(/\s/g, "").replace(/,/g, "").toLowerCase().trim()
      : "";
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  window.addEventListener("click", function (e) {
		if (
			document?.getElementById("addressInput")?.contains(e?.target) ||
			document?.getElementById("addressListSection")?.contains(e?.target)
		) {
			// Clicked in box
		} else {
			// Clicked outside the box
			setOutsideClick(true);
		}
	});

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      key={"lq-widget-street-Address" + props.isError}
    >
      <div
        className="Street-Address"
        key={"lq-widget-street-Address" + props.isError}
        ref={ref}
      >
        <StreetInputDiv
          key={"lq-widget-street-Address" + props.isError}
          ref={inputRef}
        >
          <div id="addressInput" className={userInput === defaultValue ? "placholder-text" : ""}>
          <StreetInput         
            key={"lq-widget-street-Address" + props.isError}
            required={props?.required}
            label={props.label}
            onChange={onChangeHandler}
            maxLength={50}
            disabled={props?.prospectAddress ? true : false}
             onBlur={(e) => {
              const targetValue = e?.target?.value;
              props?.isAddressEmty &&
              setTimeout(() => {
                setOutsideClick(true) 
              },1000) 
              if (!targetValue && !props?.isVerifyBussiness) {
                setUserInput(defaultValue);
                props.setAddressFieldError(true);
              } else if(!targetValue){
                props.setAddressFieldError(true);
              }
            }}
            onFocus={(e) => {
              if(userInput === defaultValue){
                setUserInput("");
               }
              if(!props?.isVerifyBussiness || props?.isShippingInfo){
              props.setAddressFieldError(false);
              }
              props?.isAddressEmty ? setOutsideClick(false):''
              setTimeout(() => {
                if (
                  inputRef?.current &&
                  inputRef.current.getElementsByTagName
                ) {
                  inputRef.current.getElementsByTagName("input")[0].focus();
                }
              });
            }}
            value={userInput}
            name="lq-widget-street-Address"
            width="100%"
            errorEvent={"change"}
            error={props.isError}
            errorText={props.isError ? props.errorMessage : ""}
            autoFocus={props.setAutoFocus}
            id="lq-widget-street-Address"
            helperText={props?.fromCarrirerModalPopUp ? "123 Street Name, City, State, ZIP Code" : ""}
            helperTextPlacement="bottom"
            success={isSuccess}
            tooltipContent={!props?.fromShoppingCart && props.label === 'Address line 1*' ?
            "Current Business Address based on Tax ID (EIN)." : ''}
          />
          </div>
          {userInput && userInput !== defaultValue && (
            <AddressSuggestionList
              streetAddressSuggestionList={pageData.addressSuggestionList}
              outSideClick={outSideClick}
              selectThisStreetAddress={selectThisStreetAddress}
            />
          )}
          {(!props?.fromShoppingCart && props?.isVerifyBussiness && !props?.fromCarrirerModalPopUp) ? <div className="helper-text">
            <Text kind="micro" size="small">
              {props.helperText ? props.helperText : props.isMultiShipping ? "" : "Eg. 123 Street Name, City, State, Zip Code"}
            </Text>
          </div> : <></>}
        </StreetInputDiv>
      </div>
    </form>
  );
});

const AddressSuggestionList = ({
  streetAddressSuggestionList,
  outSideClick,
  selectThisStreetAddress,
}) => {
  return (
    <>
      {!outSideClick && streetAddressSuggestionList ? (
        <SuggestionListDiv>
          {Object.keys(streetAddressSuggestionList).map((key, index) => {
            return (
              <div
                className="suggestion-list-item"
                key={index}
                id="addressListSection"
              >
                <span
                  // key={index}
                  key={streetAddressSuggestionList[key].ntasAddrID}
                  onClick={() =>
                    selectThisStreetAddress(streetAddressSuggestionList[key])
                  }
                >
                  {streetAddressSuggestionList[key].displayString}
                </span>
              </div>
            );
          })}
        </SuggestionListDiv>
      ) : (
        ""
      )}
    </>
  );
};
export default MapQStreetAddress;
